import { useParams } from "react-router-dom";
import AuthLayout from "../../layouts/Auth/AuthLayout";

function EmailConfirmation() {
    const { email } = useParams();
    return (
        <>
            <main className="container mx-auto">
                <AuthLayout
                    image="bg-login"
                    title="تحقق من البريد الخاص بك!"
                    description={`لقد أرسلنا إليك للتو تعليمات عبر البريد الإلكتروني
لإعادة تعيين كلمة المرور الخاصة بك ${email}`}
                    className="py-2"
                >
                    <p className="text-primary-color-primary">{email}</p>
                </AuthLayout>
            </main>
        </>
    );
}

export default EmailConfirmation;
